package com.myfield.app.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.myfield.app.section.MainSection
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint

@OptIn(DelicateApi::class)
@Page
@Composable
fun HomePage() {
    val breakpoint = rememberBreakpoint()
    val largeBreakpoint = remember(breakpoint) {
        breakpoint > Breakpoint.LG
    }

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.TopCenter
    ) {
        MainSection(
            breakpoint = breakpoint,
            largeBreakpoint = largeBreakpoint
        )
    }
}